(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-real-custom"] && !Shopify.designMode) return;
  try {
    
  function initAnnouncementBar(container) {
    if (!container) {

      return;
    }
    
    // Clear any existing auto-rotate interval from a previous initialization
if (container._autoRotateInterval) {
  clearInterval(container._autoRotateInterval);
  container._autoRotateInterval = null;
}

// If this element was already initialized, stop here (prevents duplicate listeners)
if (container.dataset.announcementInitialized === 'true') {
  return;
}

    container.dataset.announcementInitialized = 'true';
    
    const slides = container.querySelectorAll('.announcement-bar__slide');
    const indicators = container.querySelectorAll('.announcement-bar__indicator');
    const prevBtn = container.querySelector('.announcement-bar__nav--prev');
    const nextBtn = container.querySelector('.announcement-bar__nav--next');
    const slidesContainer = container.querySelector('.announcement-bar__slides');
    
    const slideCount = parseInt(container.dataset.slideCount, 10) || slides.length;
    const autoRotate = container.dataset.autoRotate === 'true';
    const rotationSpeedSeconds = parseInt(container.dataset.rotationSpeed, 10);
const rotationSpeed = (rotationSpeedSeconds > 0) ? rotationSpeedSeconds * 1000 : 5000;
    
    let currentIndex = 0;
    let isTransitioning = false;
    
    if (slideCount <= 1) {
      return;
    }
    
    function goToSlide(index, direction) {
      if (isTransitioning || index === currentIndex) {
        return;
      }
      
      isTransitioning = true;
      
      const currentSlide = slides[currentIndex];
      const nextSlide = slides[index];
      
      currentSlide.classList.add('is-exiting');
      currentSlide.classList.remove('is-active');
      
      nextSlide.classList.add('is-entering');
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          currentSlide.classList.remove('is-exiting');
          nextSlide.classList.remove('is-entering');
          nextSlide.classList.add('is-active');
          
          indicators.forEach((indicator, i) => {
            indicator.classList.toggle('is-active', i === index);
            indicator.setAttribute('aria-selected', i === index ? 'true' : 'false');
          });
          
          currentIndex = index;
          
          setTimeout(() => {
            isTransitioning = false;
          }, 400);
        });
      });
    }
    
    function nextSlide() {
      const next = (currentIndex + 1) % slideCount;
      goToSlide(next, 'next');
    }
    
    function prevSlide() {
      const prev = (currentIndex - 1 + slideCount) % slideCount;
      goToSlide(prev, 'prev');
    }
    
    function startAutoRotate() {
      if (autoRotate && !container._autoRotateInterval) {
        container._autoRotateInterval = setInterval(nextSlide, rotationSpeed);
      }
    }
    
    function stopAutoRotate() {
      if (container._autoRotateInterval) {
        clearInterval(container._autoRotateInterval);
        container._autoRotateInterval = null;
      }
    }
    
    function resetAutoRotate() {
      stopAutoRotate();
      startAutoRotate();
    }
    
    // Navigation button events
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        resetAutoRotate();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        resetAutoRotate();
      });
    }
    
    // Indicator events
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => {
        goToSlide(index);
        resetAutoRotate();
      });
    });
    
    // Pause on hover/focus
    container.addEventListener('mouseenter', stopAutoRotate);
    container.addEventListener('mouseleave', startAutoRotate);
    container.addEventListener('focusin', stopAutoRotate);
    container.addEventListener('focusout', (e) => {
      if (!container.contains(e.relatedTarget)) {
        startAutoRotate();
      }
    });
    
    // Keyboard navigation
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
        resetAutoRotate();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
        resetAutoRotate();
      }
    });
    
    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    
    slidesContainer.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    slidesContainer.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
        resetAutoRotate();
      }
    }, { passive: true });
    
    // Coupon copy functionality
    const couponButtons = container.querySelectorAll('.announcement-bar__coupon');
    
    couponButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const couponCode = button.dataset.coupon;
        
        if (!couponCode) {
          return;
        }
        
        try {
          await navigator.clipboard.writeText(couponCode);
          
          button.classList.add('copied');
          
          setTimeout(() => {
            button.classList.remove('copied');
          }, 2000);
        } catch (err) {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = couponCode;
          textArea.style.position = 'fixed';
          textArea.style.left = '-9999px';
          document.body.appendChild(textArea);
          textArea.select();
          
          try {
            document.execCommand('copy');
            button.classList.add('copied');
            
            setTimeout(() => {
              button.classList.remove('copied');
            }, 2000);
          } catch (fallbackErr) {
            console.error('Failed to copy coupon code:', fallbackErr);
          }
          
          document.body.removeChild(textArea);
        }
      });
    });
    
    // Start auto-rotation
    startAutoRotate();
    
    // Visibility change handling
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoRotate();
      } else {
        startAutoRotate();
      }
    });
  }
  
  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.announcement-bar').forEach(initAnnouncementBar);
  });
  
  // Theme editor events
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target;
    const bar = section.querySelector('.announcement-bar');
    
    if (bar) {
      bar.removeAttribute('data-announcement-initialized');
      initAnnouncementBar(bar);
    }
  });
  
  document.addEventListener('shopify:block:select', (e) => {
    const section = e.target.closest('[data-section-id]');
    
    if (section) {
      const bar = section.closest('.announcement-bar') || section.querySelector('.announcement-bar');
      
      if (bar) {
        bar.removeAttribute('data-announcement-initialized');
        initAnnouncementBar(bar);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-modal-rd"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    // =============================================
    // 1. SETUP
    // =============================================
    const selectors = {
      triggerContainer: '#bundle-injection-point',
      modal: '#bundle-modal-backdrop',
      modalFooter: '#bundle-modal-footer',
      closeBtn: '#bundle-modal-close',
      triggerBtn: '#bundle-trigger-btn',
      applyBtn: '#bundle-apply-btn',
      thumbnailsContainer: '#bundle-active-thumbnails',
      priceSummaryContainer: '#bundle-price-summary',
      pageBreakdown: '#bundle-breakdown',
      footerBreakdown: '#bundle-footer-breakdown',
      empireForm: 'form[action*="/cart/add"]',
      empireAtcButton: '.product-form--atc-button, [name="add"]', 
      dataBridge: '#bundle-hijack-data',
      totalDisplay: '#bundle-live-total',
      unsavedBar: '#bundle-unsaved-bar',
      unsavedDiscard: '#bundle-unsaved-discard',
      unsavedApply: '#bundle-unsaved-apply',
      errorToast: '#bundle-error-toast',
      errorMessage: '#bundle-error-message',
      errorClose: '#bundle-error-close'
    };

    const bridgeEl = document.querySelector(selectors.dataBridge);
    if (!bridgeEl) return; 
    
    let bundleData;
    try {
      bundleData = JSON.parse(bridgeEl.textContent);
    } catch (e) {
      console.error('Bundle Error: JSON Parse Failed', e);
      return;
    }
    
    // Working state: what's currently toggled in the modal
    let selectedAccessories = new Set();
    // Applied state: what's been confirmed and reflected on the product page
    let appliedAccessories = new Set();
    
    let isInterceptActive = false;
    let lastKnownVariantId = null;

    // Build a quick lookup map for inventory status
    const inventoryMap = {};
    bundleData.accessories.forEach(acc => {
      inventoryMap[acc.id] = acc.available !== false; // default true if missing
    });

    // =============================================
    // 2. DOM INJECTION (Smart Placement)
    // =============================================
    const empireForm = document.querySelector(selectors.empireForm);
    const triggerContainer = document.querySelector(selectors.triggerContainer);
    
    if (empireForm && triggerContainer) {
      const atcButton = empireForm.querySelector(selectors.empireAtcButton);
      if (atcButton) {
        const atcWrapper = atcButton.parentElement; 
        if (atcWrapper) {
             atcWrapper.parentNode.insertBefore(triggerContainer, atcWrapper);
        } else {
             atcButton.parentNode.insertBefore(triggerContainer, atcButton);
        }
        triggerContainer.style.display = 'block';
      }
    }

    // =============================================
    // 3. CORE LOGIC
    // =============================================
    const formatMoney = (cents) => {
      if (isNaN(cents)) cents = 0; 
      const symbol = bundleData.currencySymbol || '$';
      return symbol + (cents / 100).toFixed(2); 
    };

    function getActiveMainVariantPrice() {
      if(!empireForm) return bundleData.mainProductPrice; 
      const input = empireForm.querySelector('[name="id"]');
      if (input) lastKnownVariantId = input.value;
      if (!input || !input.value) return bundleData.mainProductPrice;
      const foundPrice = bundleData.mainVariants[input.value];
      if (foundPrice !== undefined) return foundPrice;
      return bundleData.mainProductPrice; 
    }

    function getActiveMainQuantity() {
      if(!empireForm) return 1;
      const input = empireForm.querySelector('[name="quantity"]');
      if (!input || !input.value) return 1;
      return parseInt(input.value) || 1;
    }

    function calculateTotal() {
      const mainPrice = getActiveMainVariantPrice();
      const qty = getActiveMainQuantity();
      let total = mainPrice * qty;
      if (isNaN(total)) total = 0;
      selectedAccessories.forEach(id => {
        const item = bundleData.accessories.find(acc => acc.id == id);
        if(item) total += item.price;
      });
      return total;
    }

    function calculateAppliedTotal() {
      const mainPrice = getActiveMainVariantPrice();
      const qty = getActiveMainQuantity();
      let total = mainPrice * qty;
      if (isNaN(total)) total = 0;
      appliedAccessories.forEach(id => {
        const item = bundleData.accessories.find(acc => acc.id == id);
        if(item) total += item.price;
      });
      return total;
    }

    function getAccessoriesTotal(accessorySet) {
      let total = 0;
      accessorySet.forEach(id => {
        const item = bundleData.accessories.find(acc => acc.id == id);
        if(item) total += item.price;
      });
      return total;
    }

    // =============================================
    // 4. UI UPDATE FUNCTIONS
    // =============================================

    // Update the modal's footer breakdown and total
    function updateModalUI() {
      const mainPrice = getActiveMainVariantPrice();
      const qty = getActiveMainQuantity();
      const mainLineTotal = mainPrice * qty;
      const accTotal = getAccessoriesTotal(selectedAccessories);
      const bundleTotal = mainLineTotal + accTotal;

      // Modal live total
      const modalTotalEl = document.querySelector(selectors.totalDisplay);
      if(modalTotalEl) modalTotalEl.textContent = formatMoney(bundleTotal);

      // Modal footer breakdown
      const footerBreakdown = document.querySelector(selectors.footerBreakdown);
      if (footerBreakdown) {
        const qtyLabel = qty > 1 ? (' × ' + qty) : '';
        footerBreakdown.innerHTML = 
          '<span style="color:#6B6863;">' + bundleData.mainProductTitle + qtyLabel + ': ' + formatMoney(mainLineTotal) + '</span>' +
          ' + <span style="color:#6B6863;">' + selectedAccessories.size + ' accessor' + (selectedAccessories.size === 1 ? 'y' : 'ies') + ': ' + formatMoney(accTotal) + '</span>';
      }

      // Show/hide modal footer
      const hasSelections = selectedAccessories.size > 0;
      const modalFooter = document.querySelector(selectors.modalFooter);
      if(modalFooter) modalFooter.style.display = hasSelections ? 'flex' : 'none';
    }

    // Update the on-page price breakdown (only reflects applied state)
    function updatePageUI() {
      const hasApplied = appliedAccessories.size > 0;

      const summaryContainer = document.querySelector(selectors.priceSummaryContainer);
      if(summaryContainer) summaryContainer.style.display = hasApplied ? 'block' : 'none';

      const pageBreakdown = document.querySelector(selectors.pageBreakdown);
      if (pageBreakdown && hasApplied) {
        const mainPrice = getActiveMainVariantPrice();
        const qty = getActiveMainQuantity();
        const mainLineTotal = mainPrice * qty;
        const accTotal = getAccessoriesTotal(appliedAccessories);
        const bundleTotal = mainLineTotal + accTotal;

        pageBreakdown.innerHTML = '<div class="bundle-total-line"><span>Your Total</span><span>' + formatMoney(bundleTotal) + '</span></div>';
      }
    }

    // =============================================
    // 5. CLOSE/APPLY AMBIGUITY LOGIC
    // =============================================

    function setsAreEqual(a, b) {
      if (a.size !== b.size) return false;
      for (const item of a) {
        if (!b.has(item)) return false;
      }
      return true;
    }

    function hasUnappliedChanges() {
      return !setsAreEqual(selectedAccessories, appliedAccessories);
    }

    function showUnsavedBar() {
      const bar = document.querySelector(selectors.unsavedBar);
      if (bar) bar.style.display = 'flex';
    }

    function hideUnsavedBar() {
      const bar = document.querySelector(selectors.unsavedBar);
      if (bar) bar.style.display = 'none';
    }

    // Revert modal selections back to the applied state
    function revertToApplied() {
      selectedAccessories = new Set(appliedAccessories);
      // Sync card visual states
      document.querySelectorAll('.bundle-card').forEach(card => {
        const id = parseInt(card.dataset.id);
        if (appliedAccessories.has(id)) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
      });
      updateModalUI();
    }

    // Apply current selections
    function applySelections() {
      appliedAccessories = new Set(selectedAccessories);
      isInterceptActive = appliedAccessories.size > 0;
      updateThumbnails();
      updatePageUI();
      hideUnsavedBar();
    }

    function attemptClose() {
      if (hasUnappliedChanges()) {
        showUnsavedBar();
        return; // Don't close yet
      }
      closeModal();
    }

    function closeModal() {
      const modal = document.querySelector(selectors.modal);
      if (modal) modal.classList.remove('is-open');
      hideUnsavedBar();
    }

    // =============================================
    // 6. ERROR HANDLING
    // =============================================

    let errorToastTimer = null;

    function showError(message) {
      const toast = document.querySelector(selectors.errorToast);
      const msgEl = document.querySelector(selectors.errorMessage);
      if (!toast || !msgEl) return;
      
      msgEl.textContent = message;
      toast.style.display = 'block';
      toast.classList.add('is-visible');

      clearTimeout(errorToastTimer);
      errorToastTimer = setTimeout(() => { hideError(); }, 8000);
    }

    function hideError() {
      const toast = document.querySelector(selectors.errorToast);
      if (toast) {
        toast.classList.remove('is-visible');
        toast.style.display = 'none';
      }
      clearTimeout(errorToastTimer);
    }

    const errorCloseBtn = document.querySelector(selectors.errorClose);
    if (errorCloseBtn) {
      errorCloseBtn.addEventListener('click', hideError);
    }

    // =============================================
    // 7. VARIANT POLLER
    // =============================================
    setInterval(() => {
      if(!empireForm) return;
      const input = empireForm.querySelector('[name="id"]');
      if(input && input.value !== lastKnownVariantId) {
        lastKnownVariantId = input.value;
        updateModalUI();
        updatePageUI();
      }
    }, 500);

    // =============================================
    // 8. EVENT LISTENERS
    // =============================================
    const modal = document.querySelector(selectors.modal);
    
    // Open modal — sync working state from applied state
    document.querySelector(selectors.triggerBtn).addEventListener('click', () => {
      selectedAccessories = new Set(appliedAccessories);
      // Sync card visuals
      document.querySelectorAll('.bundle-card').forEach(card => {
        const id = parseInt(card.dataset.id);
        if (selectedAccessories.has(id)) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
      });
      hideUnsavedBar();
      updateModalUI();
      modal.classList.add('is-open');
    });
    
    // Close button
    document.querySelector(selectors.closeBtn).addEventListener('click', () => {
      attemptClose();
    });
    
    // Backdrop click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) attemptClose();
    });

    // Unsaved bar — Discard
    document.querySelector(selectors.unsavedDiscard).addEventListener('click', () => {
      revertToApplied();
      closeModal();
    });

    // Unsaved bar — Apply
    document.querySelector(selectors.unsavedApply).addEventListener('click', () => {
      applySelections();
      closeModal();
    });

    // Card add/remove toggles (only for available items)
    document.querySelectorAll('.bundle-add-btn:not(.is-disabled)').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); 
        e.stopPropagation(); 
        
        const card = btn.closest('.bundle-card');
        const id = parseInt(card.dataset.id);

        // Double-check availability from data
        if (inventoryMap[id] === false) return;
        
        if (selectedAccessories.has(id)) {
          selectedAccessories.delete(id);
          card.classList.remove('is-selected');
        } else {
          selectedAccessories.add(id);
          card.classList.add('is-selected');
        }
        hideUnsavedBar(); // Hide if they continue making changes
        updateModalUI();
      });
    });

    // Apply button
    document.querySelector(selectors.applyBtn).addEventListener('click', () => {
      applySelections();
      closeModal();
    });

    // =============================================
    // 9. THUMBNAILS
    // =============================================
    function updateThumbnails() {
      const container = document.querySelector(selectors.thumbnailsContainer);
      if (!container) return;
      container.innerHTML = '';
      
      appliedAccessories.forEach(id => {
        const item = bundleData.accessories.find(acc => acc.id == id);
        if (!item) return;

        const thumb = document.createElement('div');
        thumb.className = 'bundle-thumb';
        
        thumb.innerHTML = 
          '<a href="' + item.url + '" target="_blank" class="bundle-thumb-link" title="View Product">' +
            '<img src="' + item.image + '">' +
            '<span>' + item.title + '</span>' +
          '</a>' +
          '<span class="bundle-thumb-price">' + formatMoney(item.price) + '</span>' +
          '<span class="bundle-thumb-remove" data-id="' + id + '">✕</span>';
        
        thumb.querySelector('.bundle-thumb-remove').addEventListener('click', (e) => {
          e.stopPropagation();
          appliedAccessories.delete(id);
          selectedAccessories.delete(id);
          const card = document.querySelector('.bundle-card[data-id="' + id + '"]');
          if(card) card.classList.remove('is-selected');
          
          isInterceptActive = appliedAccessories.size > 0;
          updatePageUI();
          updateThumbnails();
        });

        container.appendChild(thumb);
      });
    }

    // =============================================
    // 10. CART INTERCEPT (with Smart Error Handling)
    // =============================================
    if (empireForm) {
      const atcBtn = empireForm.querySelector(selectors.empireAtcButton);
      if(atcBtn) {
        atcBtn.addEventListener('click', async (e) => {
          if (!isInterceptActive) return; 
          
          e.preventDefault();
          e.stopPropagation();
          
          const originalText = atcBtn.innerText;
          atcBtn.innerText = 'Adding Bundle...'; 
          atcBtn.disabled = true;

          const idInput = empireForm.querySelector('[name="id"]');
          const mainVariantId = idInput ? idInput.value : bundleData.mainProductId;
          const mainQuantity = getActiveMainQuantity();

          const items = [];
          items.push({ id: parseInt(mainVariantId), quantity: mainQuantity });
          
          appliedAccessories.forEach(accId => {
            items.push({ id: accId, quantity: 1 });
          });

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });

            if (response.ok) {
              window.location.href = '/cart';
            } else {
              // Batch failed — try items individually to find the problem
              console.warn('Bundle batch add failed. Attempting individual identification...');
              await handleBatchFailure(items, atcBtn, originalText);
            }
          } catch (err) {
            console.error('Network Error:', err);
            showError('Something went wrong adding your bundle. Please check your connection and try again.');
            atcBtn.disabled = false;
            atcBtn.innerText = originalText;
          }
        });
      }
    }

    // Try each item individually to identify which one(s) failed
    async function handleBatchFailure(items, atcBtn, originalText) {
      const failedItems = [];
      const succeededItems = [];

      for (const item of items) {
        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
          if (res.ok) {
            succeededItems.push(item);
          } else {
            // Identify which product this is
            const accMatch = bundleData.accessories.find(acc => acc.id == item.id);
            const failName = accMatch ? accMatch.title : bundleData.mainProductTitle;
            failedItems.push(failName);
          }
        } catch (err) {
          const accMatch = bundleData.accessories.find(acc => acc.id == item.id);
          const failName = accMatch ? accMatch.title : bundleData.mainProductTitle;
          failedItems.push(failName);
        }
      }

      atcBtn.disabled = false;
      atcBtn.innerText = originalText;

      if (failedItems.length === 0 && succeededItems.length > 0) {
        // All actually succeeded individually (rare edge case)
        window.location.href = '/cart';
      } else if (succeededItems.length > 0 && failedItems.length > 0) {
        // Partial success
        const failList = failedItems.join(', ');
        showError('Some items were added to your cart, but the following could not be added (likely out of stock): ' + failList + '. You can review your cart or try again.');
      } else {
        // Total failure
        showError('Unable to add items to your cart. Please try again or call (888) 883-7568 for assistance.');
      }
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-modal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    
    // =============================================
    // 1. SETUP
    // =============================================
    const selectors = {
      triggerContainer: '#bundle-injection-point',
      modal: '#bundle-modal-backdrop',
      modalFooter: '#bundle-modal-footer',
      closeBtn: '#bundle-modal-close',
      triggerBtn: '#bundle-trigger-btn',
      applyBtn: '#bundle-apply-btn',
      thumbnailsContainer: '#bundle-active-thumbnails',
      priceSummaryContainer: '#bundle-price-summary',
      pageBreakdown: '#bundle-breakdown',
      footerBreakdown: '#bundle-footer-breakdown',
      empireForm: 'form[action*="/cart/add"]',
      empireAtcButton: '.product-form--atc-button, [name="add"]', 
      dataBridge: '#bundle-hijack-data',
      totalDisplay: '#bundle-live-total',
      unsavedBar: '#bundle-unsaved-bar',
      unsavedDiscard: '#bundle-unsaved-discard',
      unsavedApply: '#bundle-unsaved-apply',
      errorToast: '#bundle-error-toast',
      errorMessage: '#bundle-error-message',
      errorClose: '#bundle-error-close'
    };

    const bridgeEl = document.querySelector(selectors.dataBridge);
    if (!bridgeEl) return; 
    
    let bundleData;
    try {
      bundleData = JSON.parse(bridgeEl.textContent);
    } catch (e) {
      console.error('Bundle Error: JSON Parse Failed', e);
      return;
    }
    
    // Working state: what's currently toggled in the modal
    let selectedAccessories = new Set();
    // Applied state: what's been confirmed and reflected on the product page
    let appliedAccessories = new Set();
    
    let isInterceptActive = false;
    let lastKnownVariantId = null;

    // Build a quick lookup map for inventory status
    const inventoryMap = {};
    bundleData.accessories.forEach(acc => {
      inventoryMap[acc.id] = acc.available !== false; // default true if missing
    });

    // =============================================
    // 2. DOM INJECTION (Smart Placement)
    // =============================================
    const empireForm = document.querySelector(selectors.empireForm);
    const triggerContainer = document.querySelector(selectors.triggerContainer);
    
    if (empireForm && triggerContainer) {
      const atcButton = empireForm.querySelector(selectors.empireAtcButton);
      if (atcButton) {
        const atcWrapper = atcButton.parentElement; 
        if (atcWrapper) {
             atcWrapper.parentNode.insertBefore(triggerContainer, atcWrapper);
        } else {
             atcButton.parentNode.insertBefore(triggerContainer, atcButton);
        }
        triggerContainer.style.display = 'block';
      }
    }

    // =============================================
    // 3. CORE LOGIC
    // =============================================
    const formatMoney = (cents) => {
      if (isNaN(cents)) cents = 0; 
      const symbol = bundleData.currencySymbol || '$';
      return symbol + (cents / 100).toFixed(2); 
    };

    function getActiveMainVariantPrice() {
      if(!empireForm) return bundleData.mainProductPrice; 
      const input = empireForm.querySelector('[name="id"]');
      if (input) lastKnownVariantId = input.value;
      if (!input || !input.value) return bundleData.mainProductPrice;
      const foundPrice = bundleData.mainVariants[input.value];
      if (foundPrice !== undefined) return foundPrice;
      return bundleData.mainProductPrice; 
    }

    function getActiveMainQuantity() {
      if(!empireForm) return 1;
      const input = empireForm.querySelector('[name="quantity"]');
      if (!input || !input.value) return 1;
      return parseInt(input.value) || 1;
    }

    function calculateTotal() {
      const mainPrice = getActiveMainVariantPrice();
      const qty = getActiveMainQuantity();
      let total = mainPrice * qty;
      if (isNaN(total)) total = 0;
      selectedAccessories.forEach(id => {
        const item = bundleData.accessories.find(acc => acc.id == id);
        if(item) total += item.price;
      });
      return total;
    }

    function calculateAppliedTotal() {
      const mainPrice = getActiveMainVariantPrice();
      const qty = getActiveMainQuantity();
      let total = mainPrice * qty;
      if (isNaN(total)) total = 0;
      appliedAccessories.forEach(id => {
        const item = bundleData.accessories.find(acc => acc.id == id);
        if(item) total += item.price;
      });
      return total;
    }

    function getAccessoriesTotal(accessorySet) {
      let total = 0;
      accessorySet.forEach(id => {
        const item = bundleData.accessories.find(acc => acc.id == id);
        if(item) total += item.price;
      });
      return total;
    }

    // =============================================
    // 4. UI UPDATE FUNCTIONS
    // =============================================

    // Update the modal's footer breakdown and total
    function updateModalUI() {
      const mainPrice = getActiveMainVariantPrice();
      const qty = getActiveMainQuantity();
      const mainLineTotal = mainPrice * qty;
      const accTotal = getAccessoriesTotal(selectedAccessories);
      const bundleTotal = mainLineTotal + accTotal;

      // Modal live total
      const modalTotalEl = document.querySelector(selectors.totalDisplay);
      if(modalTotalEl) modalTotalEl.textContent = formatMoney(bundleTotal);

      // Modal footer breakdown
      const footerBreakdown = document.querySelector(selectors.footerBreakdown);
      if (footerBreakdown) {
        const qtyLabel = qty > 1 ? (' × ' + qty) : '';
        footerBreakdown.innerHTML = 
          '<span style="color:#666;">' + bundleData.mainProductTitle + qtyLabel + ': ' + formatMoney(mainLineTotal) + '</span>' +
          ' + <span style="color:#666;">' + selectedAccessories.size + ' accessor' + (selectedAccessories.size === 1 ? 'y' : 'ies') + ': ' + formatMoney(accTotal) + '</span>';
      }

      // Show/hide modal footer
      const hasSelections = selectedAccessories.size > 0;
      const modalFooter = document.querySelector(selectors.modalFooter);
      if(modalFooter) modalFooter.style.display = hasSelections ? 'flex' : 'none';
    }

    // Update the on-page price breakdown (only reflects applied state)
    function updatePageUI() {
      const hasApplied = appliedAccessories.size > 0;

      const summaryContainer = document.querySelector(selectors.priceSummaryContainer);
      if(summaryContainer) summaryContainer.style.display = hasApplied ? 'block' : 'none';

      const pageBreakdown = document.querySelector(selectors.pageBreakdown);
      if (pageBreakdown && hasApplied) {
        const mainPrice = getActiveMainVariantPrice();
        const qty = getActiveMainQuantity();
        const mainLineTotal = mainPrice * qty;
        const accTotal = getAccessoriesTotal(appliedAccessories);
        const bundleTotal = mainLineTotal + accTotal;

        pageBreakdown.innerHTML = '<div class="bundle-total-line"><span>Your Total</span><span>' + formatMoney(bundleTotal) + '</span></div>';
      }
    }

    // =============================================
    // 5. CLOSE/APPLY AMBIGUITY LOGIC
    // =============================================

    function setsAreEqual(a, b) {
      if (a.size !== b.size) return false;
      for (const item of a) {
        if (!b.has(item)) return false;
      }
      return true;
    }

    function hasUnappliedChanges() {
      return !setsAreEqual(selectedAccessories, appliedAccessories);
    }

    function showUnsavedBar() {
      const bar = document.querySelector(selectors.unsavedBar);
      if (bar) bar.style.display = 'flex';
    }

    function hideUnsavedBar() {
      const bar = document.querySelector(selectors.unsavedBar);
      if (bar) bar.style.display = 'none';
    }

    // Revert modal selections back to the applied state
    function revertToApplied() {
      selectedAccessories = new Set(appliedAccessories);
      // Sync card visual states
      document.querySelectorAll('.bundle-card').forEach(card => {
        const id = parseInt(card.dataset.id);
        if (appliedAccessories.has(id)) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
      });
      updateModalUI();
    }

    // Apply current selections
    function applySelections() {
      appliedAccessories = new Set(selectedAccessories);
      isInterceptActive = appliedAccessories.size > 0;
      updateThumbnails();
      updatePageUI();
      hideUnsavedBar();
    }

    function attemptClose() {
      if (hasUnappliedChanges()) {
        showUnsavedBar();
        return; // Don't close yet
      }
      closeModal();
    }

    function closeModal() {
      const modal = document.querySelector(selectors.modal);
      if (modal) modal.classList.remove('is-open');
      hideUnsavedBar();
    }

    // =============================================
    // 6. ERROR HANDLING
    // =============================================

    let errorToastTimer = null;

    function showError(message) {
      const toast = document.querySelector(selectors.errorToast);
      const msgEl = document.querySelector(selectors.errorMessage);
      if (!toast || !msgEl) return;
      
      msgEl.textContent = message;
      toast.style.display = 'block';
      toast.classList.add('is-visible');

      clearTimeout(errorToastTimer);
      errorToastTimer = setTimeout(() => { hideError(); }, 8000);
    }

    function hideError() {
      const toast = document.querySelector(selectors.errorToast);
      if (toast) {
        toast.classList.remove('is-visible');
        toast.style.display = 'none';
      }
      clearTimeout(errorToastTimer);
    }

    const errorCloseBtn = document.querySelector(selectors.errorClose);
    if (errorCloseBtn) {
      errorCloseBtn.addEventListener('click', hideError);
    }

    // =============================================
    // 7. VARIANT POLLER
    // =============================================
    setInterval(() => {
      if(!empireForm) return;
      const input = empireForm.querySelector('[name="id"]');
      if(input && input.value !== lastKnownVariantId) {
        lastKnownVariantId = input.value;
        updateModalUI();
        updatePageUI();
      }
    }, 500);

    // =============================================
    // 8. EVENT LISTENERS
    // =============================================
    const modal = document.querySelector(selectors.modal);
    
    // Open modal — sync working state from applied state
    document.querySelector(selectors.triggerBtn).addEventListener('click', () => {
      selectedAccessories = new Set(appliedAccessories);
      // Sync card visuals
      document.querySelectorAll('.bundle-card').forEach(card => {
        const id = parseInt(card.dataset.id);
        if (selectedAccessories.has(id)) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
      });
      hideUnsavedBar();
      updateModalUI();
      modal.classList.add('is-open');
    });
    
    // Close button
    document.querySelector(selectors.closeBtn).addEventListener('click', () => {
      attemptClose();
    });
    
    // Backdrop click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) attemptClose();
    });

    // Unsaved bar — Discard
    document.querySelector(selectors.unsavedDiscard).addEventListener('click', () => {
      revertToApplied();
      closeModal();
    });

    // Unsaved bar — Apply
    document.querySelector(selectors.unsavedApply).addEventListener('click', () => {
      applySelections();
      closeModal();
    });

    // Card add/remove toggles (only for available items)
    document.querySelectorAll('.bundle-add-btn:not(.is-disabled)').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); 
        e.stopPropagation(); 
        
        const card = btn.closest('.bundle-card');
        const id = parseInt(card.dataset.id);

        // Double-check availability from data
        if (inventoryMap[id] === false) return;
        
        if (selectedAccessories.has(id)) {
          selectedAccessories.delete(id);
          card.classList.remove('is-selected');
        } else {
          selectedAccessories.add(id);
          card.classList.add('is-selected');
        }
        hideUnsavedBar(); // Hide if they continue making changes
        updateModalUI();
      });
    });

    // Apply button
    document.querySelector(selectors.applyBtn).addEventListener('click', () => {
      applySelections();
      closeModal();
    });

    // =============================================
    // 9. THUMBNAILS
    // =============================================
    function updateThumbnails() {
      const container = document.querySelector(selectors.thumbnailsContainer);
      if (!container) return;
      container.innerHTML = '';
      
      appliedAccessories.forEach(id => {
        const item = bundleData.accessories.find(acc => acc.id == id);
        if (!item) return;

        const thumb = document.createElement('div');
        thumb.className = 'bundle-thumb';
        
        thumb.innerHTML = 
          '<a href="' + item.url + '" target="_blank" class="bundle-thumb-link" title="View Product">' +
            '<img src="' + item.image + '">' +
            '<span>' + item.title + '</span>' +
          '</a>' +
          '<span class="bundle-thumb-price">' + formatMoney(item.price) + '</span>' +
          '<span class="bundle-thumb-remove" data-id="' + id + '">✕</span>';
        
        thumb.querySelector('.bundle-thumb-remove').addEventListener('click', (e) => {
          e.stopPropagation();
          appliedAccessories.delete(id);
          selectedAccessories.delete(id);
          const card = document.querySelector('.bundle-card[data-id="' + id + '"]');
          if(card) card.classList.remove('is-selected');
          
          isInterceptActive = appliedAccessories.size > 0;
          updatePageUI();
          updateThumbnails();
        });

        container.appendChild(thumb);
      });
    }

    // =============================================
    // 10. CART INTERCEPT (with Smart Error Handling)
    // =============================================
    if (empireForm) {
      const atcBtn = empireForm.querySelector(selectors.empireAtcButton);
      if(atcBtn) {
        atcBtn.addEventListener('click', async (e) => {
          if (!isInterceptActive) return; 
          
          e.preventDefault();
          e.stopPropagation();
          
          const originalText = atcBtn.innerText;
          atcBtn.innerText = 'Adding Bundle...'; 
          atcBtn.disabled = true;

          const idInput = empireForm.querySelector('[name="id"]');
          const mainVariantId = idInput ? idInput.value : bundleData.mainProductId;
          const mainQuantity = getActiveMainQuantity();

          const items = [];
          items.push({ id: parseInt(mainVariantId), quantity: mainQuantity });
          
          appliedAccessories.forEach(accId => {
            items.push({ id: accId, quantity: 1 });
          });

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });

            if (response.ok) {
              window.location.href = '/cart';
            } else {
              // Batch failed — try items individually to find the problem
              console.warn('Bundle batch add failed. Attempting individual identification...');
              await handleBatchFailure(items, atcBtn, originalText);
            }
          } catch (err) {
            console.error('Network Error:', err);
            showError('Something went wrong adding your bundle. Please check your connection and try again.');
            atcBtn.disabled = false;
            atcBtn.innerText = originalText;
          }
        });
      }
    }

    // Try each item individually to identify which one(s) failed
    async function handleBatchFailure(items, atcBtn, originalText) {
      const failedItems = [];
      const succeededItems = [];

      for (const item of items) {
        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
          if (res.ok) {
            succeededItems.push(item);
          } else {
            // Identify which product this is
            const accMatch = bundleData.accessories.find(acc => acc.id == item.id);
            const failName = accMatch ? accMatch.title : bundleData.mainProductTitle;
            failedItems.push(failName);
          }
        } catch (err) {
          const accMatch = bundleData.accessories.find(acc => acc.id == item.id);
          const failName = accMatch ? accMatch.title : bundleData.mainProductTitle;
          failedItems.push(failName);
        }
      }

      atcBtn.disabled = false;
      atcBtn.innerText = originalText;

      if (failedItems.length === 0 && succeededItems.length > 0) {
        // All actually succeeded individually (rare edge case)
        window.location.href = '/cart';
      } else if (succeededItems.length > 0 && failedItems.length > 0) {
        // Partial success
        const failList = failedItems.join(', ');
        showError('Some items were added to your cart, but the following could not be added (likely out of stock): ' + failList + '. You can review your cart or try again.');
      } else {
        // Total failure
        showError('Unable to add items to your cart. Please try again or call (888) 883-7568 for assistance.');
      }
    }

  });

  } catch(e) { console.error(e); }
})();
})();
